import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../components/Button";
import Card from "../components/Card";
import { Stack } from "../components/Layout";
import PageShell from "../components/PageShell";
import { Heading, Text } from "../components/Typography";
import { apiGet, ApiError } from "../services/apiClient";

const FormCard = styled(Card)`
  width: 100%;
`;

const ErrorText = styled(Text)`
  color: ${({ theme }) => theme.colors.danger};
  font-size: ${({ theme }) => theme.typography.sizes.sm};
`;

const Count = styled.span`
  font-weight: ${({ theme }) => theme.typography.weights.medium};
`;

function DevPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [apiUses, setApiUses] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function fetchApiUses() {
      setLoading(true);
      setError("");
      setApiUses(null);

      try {
        const data = await apiGet("/api_uses");
        if (!cancelled) {
          setApiUses(data.api_uses);
        }
      } catch (err) {
        if (cancelled) {
          return;
        }

        if (err instanceof ApiError && err.status === 401) {
          setError("Your session has expired. Please sign in again.");
        } else {
          const message =
            err instanceof ApiError
              ? err.message
              : "Could not load API usage. Please try again.";
          setError(message);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    fetchApiUses();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <PageShell narrow>
      <FormCard padding={4}>
        <Stack $gap={4}>
          <Heading $size="xl">Dev tools</Heading>

          <Stack $gap={2}>
            {loading && <Text $muted>Loading API usage...</Text>}
            {!loading && error && <ErrorText>{error}</ErrorText>}
            {!loading && !error && apiUses !== null && (
              <Text>
                API key uses: <Count>{apiUses}</Count>
              </Text>
            )}
          </Stack>

          <Stack $gap={2}>
            <Button type="button" variant="secondary" title="Coming soon">
              Regenerate API key
            </Button>
            <Button
              type="button"
              variant="ghost"
              onClick={() => navigate("/UserDashboard")}
            >
              Back to dashboard
            </Button>
          </Stack>
        </Stack>
      </FormCard>
    </PageShell>
  );
}

export default DevPage;
